// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"316":"medium","429":"contactUs","443":"about","501":"public","577":"shopping","977":"commodity"}[chunkId] + "." + {"316":"9ee19b32","429":"90dc0ebe","443":"a32f2fe1","501":"145aacea","577":"aa64aef9","977":"1d2c74f8"}[chunkId] + ".js";
};